var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPressedStopwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M789.139+316.67C795.202+324.806+794.411+337.326+787.373+344.635L751.31+382.082C744.271+389.391+732.437+389.83+724.877+383.063L695.484+356.754C687.924+349.987+687.34+338.426+694.18+330.932L730.441+291.201C737.281+283.706+749.755+282.063+758.302+287.531L789.139+316.67Z",
    opacity: 1,
    fill: "#2facec"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2facec",
    d: "M513.347+912C322.871+912+170.49+759.619+170.49+569.143C170.49+378.667+322.871+226.286+513.347+226.286C703.823+226.286+856.204+378.667+856.204+569.143C856.204+759.619+703.823+912+513.347+912Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.347+864.143C349.458+864.143+218.347+733.032+218.347+569.143C218.347+405.254+349.458+274.143+513.347+274.143C677.236+274.143+808.347+405.254+808.347+569.143C808.347+733.032+677.236+864.143+513.347+864.143Z",
    fill: "#1a6ac9",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.347+302.476C364.776+302.476+246.68+420.571+246.68+569.143C246.68+717.714+364.776+835.81+513.347+835.81C661.919+835.81+780.014+717.714+780.014+569.143C780.014+420.571+661.919+302.476+513.347+302.476Z",
    opacity: 1,
    fill: "#fff7d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572+212.408L454.694+212.408C433.986+212.408+417.199+195.621+417.199+174.913L417.199+173.713C417.199+153.005+433.986+136.218+454.694+136.218L572+136.218C592.708+136.218+609.495+153.005+609.495+173.713L609.495+174.913C609.495+195.621+592.708+212.408+572+212.408Z",
    opacity: 1,
    fill: "#2facec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.912+188.19L551.782+188.19L551.782+264.381L474.912+264.381L474.912+188.19Z",
    opacity: 1,
    fill: "#2facec"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb400",
    opacity: 1,
    d: "M513.347+492.952C471.268+492.952+437.157+527.064+437.157+569.143C437.157+611.222+471.268+645.333+513.347+645.333C555.426+645.333+589.538+611.222+589.538+569.143C589.538+527.064+555.426+492.952+513.347+492.952Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb400",
    d: "M523.378+486.802C523.378+486.802+620.134+377.248+635.941+388.027C651.749+398.807+586.607+529.92+586.607+529.92L528.082+616.092L464.914+573.492L523.378+486.802Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M513.347+524.143C488.494+524.143+468.347+544.29+468.347+569.143C468.347+593.996+488.494+614.143+513.347+614.143C538.2+614.143+558.347+593.996+558.347+569.143C558.347+544.29+538.2+524.143+513.347+524.143Z",
    fill: "#1a6ac9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressedStopwatch);
export default __webpack_public_path__ + "static/media/PressedStopwatch.7e57cf20d1a804aeb0699c032231dfd1.svg";
export { ForwardRef as ReactComponent };